var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSigned(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "163px",
    height: "106px",
    viewBox: "0 0 163 106",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "16--Emails-template",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.11--Email---user-requested-my-dpa",
    transform: "translate(-214.000000, -92.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Image",
    transform: "translate(0.000000, 61.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(214.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration-document",
    transform: "translate(27.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116,55.2212389 C116,24.7239292 91.375125,0 61,0 C30.624875,0 6,24.7239292 6,55.2212389 C6,63.3470442 7.76275,71.0545487 10.9005,78 L111.0995,78 C114.23725,71.0545487 116,63.3470442 116,55.2212389",
    id: "Fill-1",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 78.000000)",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L3,0",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,0 L119,0",
    id: "Stroke-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,0 L113,0",
    id: "Stroke-3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23,91.4993412 C23,92.8801054 32.849441,94 45,94 C57.150559,94 67,92.8801054 67,91.4993412 C67,90.1185771 57.150559,89 45,89 C32.849441,89 23,90.1185771 23,91.4993412",
    id: "Fill-3",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,91 C55.1849802,91 52.0909091,87.8964427 52.0909091,84.0666667 L52.0909091,45.9333333 C52.0909091,42.1049275 48.9982034,39 45.1818182,39 L21,39 C24.8163852,39 27.9090909,42.1049275 27.9090909,45.9333333 L27.9090909,84.0666667 C27.9090909,87.8964427 31.0031621,91 34.8181818,91 L59,91 Z",
    id: "Fill-5",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,46.7365618 C28,43.0168081 24.8652174,40 20.9986166,40 C17.1333992,40 14,43.0168081 14,46.7365618 L14,54.4689632 C14,55.3143618 14.7124506,56 15.5909091,56 L28,56 L28,46.7365618 Z",
    id: "Fill-7",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,46.7365618 C28,43.0168081 24.8652174,40 20.9986166,40 C17.1333992,40 14,43.0168081 14,46.7365618 L14,54.4689632 C14,55.3143618 14.7124506,56 15.5909091,56 L28,56 L28,46.7365618 Z",
    id: "Stroke-9",
    stroke: "#7450C8",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,91 C55.1849802,91 52.0909091,87.8964427 52.0909091,84.0666667 L52.0909091,45.9333333 C52.0909091,42.1049275 48.9982034,39 45.1818182,39 L21,39 C24.8163852,39 27.9090909,42.1049275 27.9090909,45.9333333 L27.9090909,84.0666667 C27.9090909,87.8964427 31.0031621,91 34.8181818,91 L59,91 Z",
    id: "Stroke-11",
    stroke: "#7450C8",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.110452,91 C63.1374828,91 66.358563,87.4875494 65.9678402,83.3124506 C65.626128,79.6727273 62.4132163,77 58.8150274,77 L39.6328553,77 C38.8718309,77 38.5764064,77.966996 39.1822309,78.4359684 C40.826806,79.7156126 41.8887006,81.7312253 41.8887006,84 C41.8887006,87.8666008 38.8051221,91 35,91 L59.110452,91 Z",
    id: "Fill-13",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.110452,91 C63.1374828,91 66.358563,87.4875494 65.9678402,83.3124506 C65.626128,79.6727273 62.4132163,77 58.8150274,77 L39.6328553,77 C38.8718309,77 38.5764064,77.966996 39.1822309,78.4359684 C40.826806,79.7156126 41.8887006,81.7312253 41.8887006,84 C41.8887006,87.8666008 38.8051221,91 35,91 L59.110452,91 Z",
    id: "Stroke-15",
    stroke: "#7450C8",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,50 L34,50",
    id: "Stroke-17",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,55 L34,55",
    id: "Stroke-19",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45,60 L38,60",
    id: "Stroke-21",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45,65 L40,65",
    id: "Stroke-23",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-25",
    fill: "#DFE4EE",
    points: "67.3849329 57 60 49.6157021 66.1534228 41 76 50.8457305"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7891845,51 L66,41.3368043 L93.675376,17.2409318 C95.6575628,15.5097668 98.6616222,15.6002411 100.533003,17.4475373 C102.433112,19.3218408 102.494671,22.3426022 100.675272,24.292526 L75.7891845,51 Z",
    id: "Fill-27",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0365459,66.1571318 C58.1469545,67.3437163 56.7521974,68.0542791 55.2700077,68.0750964 C52.9356978,68.1070162 49.3287587,68.4373169 47,70 C48.5599075,67.6545875 48.891596,64.0573631 48.9249036,61.7286045 C48.9457209,60.245027 49.6548959,58.8544333 50.8414803,57.9634541 L58.7922899,52 L65,58.2063223 L59.0365459,66.1571318 Z",
    id: "Fill-29",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-31",
    fill: "#FFFFFF",
    points: "64.0004472 59 58 52.9995528 59.8016098 50 67 57.1997317"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-33",
    stroke: "#7450C8",
    strokeLinejoin: "round",
    points: "64.0004472 59 58 52.9995528 59.8016098 50 67 57.1997317"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0365459,66.1571318 C58.1469545,67.3437163 56.7521974,68.0542791 55.2700077,68.0750964 C52.9356978,68.1070162 49.3287587,68.4373169 47,70 C48.5599075,67.6545875 48.891596,64.0573631 48.9249036,61.7286045 C48.9457209,60.245027 49.6548959,58.8544333 50.8414803,57.9634541 L58.7922899,52 L65,58.2063223 L59.0365459,66.1571318 Z",
    id: "Stroke-35",
    stroke: "#7450C8",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-37",
    stroke: "#7450C8",
    strokeLinejoin: "round",
    points: "67.3849329 57 60 49.6157021 66.1534228 41 76 50.8457305"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5606719,63.5606719 C54.9749012,64.1464427 54.0250988,64.1464427 53.4393281,63.5606719 C52.8535573,62.9749012 52.8535573,62.0250988 53.4393281,61.4393281 C54.0250988,60.8535573 54.9749012,60.8535573 55.5606719,61.4393281 C56.1464427,62.0250988 56.1464427,62.9749012 55.5606719,63.5606719",
    id: "Fill-39",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5606719,63.5606719 C54.9749012,64.1464427 54.0250988,64.1464427 53.4393281,63.5606719 C52.8535573,62.9749012 52.8535573,62.0250988 53.4393281,61.4393281 C54.0250988,60.8535573 54.9749012,60.8535573 55.5606719,61.4393281 C56.1464427,62.0250988 56.1464427,62.9749012 55.5606719,63.5606719 Z",
    id: "Stroke-41",
    stroke: "#7450C8",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53,64 L47,70",
    id: "Stroke-43",
    stroke: "#7450C8",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9765129,26 L100.031651,27.0727898 C101.281364,28.3420806 101.327069,30.3867541 100.136121,31.7131365 L90,43",
    id: "Stroke-45",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-47",
    fill: "#FFFFFF",
    points: "68.5718151 39 66 41.2769161 75.6811725 51 78 48.467678"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-49",
    stroke: "#7450C8",
    strokeLinejoin: "round",
    points: "68.5718151 39 66 41.2769161 75.6811725 51 78 48.467678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7891845,51 L66,41.3368043 L93.675376,17.2409318 C95.6575628,15.5097668 98.6616222,15.6002411 100.533003,17.4475373 C102.433112,19.3218408 102.494671,22.3426022 100.675272,24.292526 L75.7891845,51 Z",
    id: "Stroke-51",
    stroke: "#7450C8",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Illustration",
    transform: "translate(19.000000, 0.000000)",
    stroke: "#7450C8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.38437124,0.129439389 C8.1567254,-0.0431464632 7.84152348,-0.0431464632 7.61562876,0.129439389 C5.61584765,1.64044614 3.19754843,2.70061638 0.549852249,3.07572645 C0.234650323,3.11975345 0,3.39272087 0,3.71323745 L0,9.33988846 C0,14.5544467 3.1712816,19.0645729 7.75746963,20.9524508 C7.91156835,21.0158497 8.08668053,21.0158497 8.24253037,20.9524508 C12.8252162,19.0645729 16,14.5562078 16,9.33988846 L16,3.71147637 C16,3.39095979 15.7653497,3.11975345 15.4483966,3.07572645 C12.8024516,2.70061638 10.3859035,1.64044614 8.38437124,0.129439389 Z",
    id: "Stroke-125"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon-bubble",
    transform: "translate(141.000000, 26.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "circle"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 11,
    cy: 11,
    r: 11
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fillOpacity: 0.3,
    fill: "#EBA601",
    cx: 11,
    cy: 11,
    r: 11
  })), /*#__PURE__*/React.createElement("g", {
    id: "data-sharing",
    transform: "translate(5.000000, 5.000000)",
    fill: "#EBA601",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0388571,1.476 C9.60571337,0.57103181 8.68578607,0.000623529021 7.6826038,0.0149862707 C6.67942153,0.0293490125 5.77620122,0.625859627 5.36914286,1.54285714 L3.08571429,1.54285714 C2.23361781,1.54285714 1.54285714,2.23361781 1.54285714,3.08571429 L1.54285714,5.14285714 C1.54285714,5.4268893 1.7731107,5.65714286 2.05714286,5.65714286 C2.34117501,5.65714286 2.57142857,5.4268893 2.57142857,5.14285714 L2.57142857,3.08571429 C2.57142857,2.80168213 2.80168213,2.57142857 3.08571429,2.57142857 L4.51542857,2.57142857 C4.25942273,2.85307046 4.11655403,3.21940048 4.11428571,3.6 C4.11428571,4.45209647 4.80504639,5.14285714 5.65714286,5.14285714 L9.42685714,5.14285714 C10.3519371,5.14952178 11.1447286,4.48297076 11.2970223,3.57048839 C11.449316,2.65800603 10.9159606,1.77012054 10.0388571,1.476 Z M9.42685714,4.11428571 L5.65714286,4.11428571 C5.3731107,4.11428571 5.14285714,3.88403216 5.14285714,3.6 C5.14285714,3.31596784 5.3731107,3.08571429 5.65714286,3.08571429 C5.94117501,3.08571429 6.17142857,2.85546073 6.17142857,2.57142857 C6.16285567,1.81325899 6.70644825,1.16122951 7.45378917,1.03326018 C8.20113009,0.905290839 8.93069069,1.33931464 9.17485714,2.05714286 C9.23475628,2.2372142 9.3889533,2.36966548 9.576,2.40171429 C9.99173067,2.47059005 10.293935,2.83411126 10.2857143,3.25542857 C10.2857143,3.48321165 10.1952278,3.70166532 10.0341609,3.86273228 C9.87309389,4.02379924 9.65464022,4.11428571 9.42685714,4.11428571 Z M9.25714286,6.17142857 C8.9731107,6.17142857 8.74285714,6.40168213 8.74285714,6.68571429 L8.74285714,8.22857143 C8.74285714,8.51260359 8.51260359,8.74285714 8.22857143,8.74285714 L7.06628571,8.74285714 C6.86511302,8.22772434 6.44758423,7.82712239 5.92457143,7.64742857 C5.4463038,6.6324577 4.36516421,6.04476475 3.25330755,6.19536544 C2.14145089,6.34596613 1.25560457,7.2000868 1.06457143,8.30571429 C0.345159057,8.54216728 -0.096300413,9.26578273 0.0225937413,10.0136653 C0.141487896,10.7615479 0.78558487,11.3125877 1.54285714,11.3142857 L5.31257143,11.3142857 C6.22121332,11.3142857 7.00014654,10.6651747 7.164,9.77142857 L8.22857143,9.77142857 C9.0806679,9.77142857 9.77142857,9.0806679 9.77142857,8.22857143 L9.77142857,6.68571429 C9.77142857,6.40168213 9.54117501,6.17142857 9.25714286,6.17142857 Z M5.31257143,10.2857143 L1.54285714,10.2857143 C1.25882499,10.2857143 1.02857143,10.0554607 1.02857143,9.77142857 C1.02857143,9.48739641 1.25882499,9.25714286 1.54285714,9.25714286 C1.8268893,9.25714286 2.05714286,9.0268893 2.05714286,8.74285714 C2.04856996,7.98468756 2.59216253,7.33265808 3.33950345,7.20468875 C4.08684438,7.07671941 4.81640498,7.51074321 5.06057143,8.22857143 C5.12047057,8.40864277 5.27466759,8.54109405 5.46171429,8.57314286 C5.87744496,8.64201862 6.17964933,9.00553983 6.17142857,9.42685714 C6.17142857,9.65464022 6.0809421,9.87309389 5.91987514,10.0341609 C5.75880818,10.1952278 5.54035451,10.2857143 5.31257143,10.2857143 Z",
    id: "Shape"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Icon-bubble",
    transform: "translate(0.000000, 53.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "circle"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 13.5,
    cy: 13.5,
    r: 13.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fillOpacity: 0.3,
    fill: "#1DDCC0",
    cx: 13.5,
    cy: 13.5,
    r: 13.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "check-circle",
    transform: "translate(6.000000, 6.000000)",
    fill: "#1DDCC0",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1099221,5.39672727 L6.70020779,8.81438961 L5.38877922,7.50296104 C5.19453687,7.27614258 4.88954746,7.1773437 4.59920466,7.24718467 C4.30886186,7.31702564 4.0821685,7.54371901 4.01232753,7.8340618 C3.94248656,8.1244046 4.04128544,8.42939402 4.2681039,8.62363636 L6.1358961,10.4993766 C6.28589081,10.6481534 6.4889462,10.7310916 6.70020779,10.7298701 C6.90871689,10.7289922 7.10853051,10.6462122 7.25657143,10.4993766 L11.2305974,6.52535065 C11.3810641,6.37611278 11.4656994,6.17296386 11.4656994,5.96103896 C11.4656994,5.74911406 11.3810641,5.54596514 11.2305974,5.39672727 C10.9205936,5.08856255 10.4199259,5.08856255 10.1099221,5.39672727 Z M7.94805195,3.52964411e-16 C3.55846407,-1.76482205e-16 3.52964411e-16,3.55846407 0,7.94805195 C-3.52964411e-16,12.3376398 3.55846407,15.8961039 7.94805195,15.8961039 C12.3376398,15.8961039 15.8961039,12.3376398 15.8961039,7.94805195 C15.8961039,5.84009751 15.0587223,3.8184794 13.5681734,2.32793052 C12.0776245,0.83738164 10.0560064,1.76482205e-16 7.94805195,3.52964411e-16 Z M7.94805195,14.3064935 C4.43638164,14.3064935 1.58961039,11.4597223 1.58961039,7.94805195 C1.58961039,4.43638164 4.43638164,1.58961039 7.94805195,1.58961039 C11.4597223,1.58961039 14.3064935,4.43638164 14.3064935,7.94805195 C14.3064935,9.6344155 13.6365882,11.25171 12.4441491,12.4441491 C11.25171,13.6365882 9.6344155,14.3064935 7.94805195,14.3064935 Z",
    id: "Shape"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSigned);
export default __webpack_public_path__ + "static/media/Signed.44dc93ce36018092c4b62a9e38fbcfbc.svg";
export { ForwardRef as ReactComponent };